<template>
  <div class='h100-40 width-100vw h-scroll'>
    <ConfigRecoverTableButton @notice='notice' @searchKey='request' ref='recoverButton'></ConfigRecoverTableButton>
    <ejs-treegrid id="myGrid" ref='grid' :treeColumnIndex='index' :dataSource='nodeList' childMapping="subtasks" :allowResizing='true'
                  autoCheckHierarchy="true" collapsed="true" :enableAltRow="false" :rowDataBound="rowDataBound">
      <e-columns>
        <e-column field='neId' :headerText='$t("DataManagent.neid")' width='6%' showCheckbox="true" clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neName' :headerText='$t("Software.td_neID")' width='8%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neSoftVersion' :headerText='$t("Topo.bakSoftVersion")' width='12%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='curSoftVersion' :headerText='$t("Topo.devSoftVersion")' width='12%' clipMode='EllipsisWithTooltip' v-if='isCheckVersion'></e-column>
        <e-column field='state' :headerText='$t("System.state")' width='5%' clipMode='EllipsisWithTooltip'  :valueAccessor="stateTypeFormatter" ></e-column>
        <e-column field='errorString' :headerText='$t("TS.ts_register_callCause")' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='intoDbTime' :headerText='$t("Software.td_createTime")' width='11%' type='date' :format='dateFormatOptions' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='id' :isPrimaryKey='true' :visible='false' ></e-column>
        <e-column field='fileName'  :visible='false' ></e-column>
        <e-column field='filePath'  :visible='false' ></e-column>
      </e-columns>
    </ejs-treegrid>
    <ejs-pager ref='pager' @click='request' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>

     <CustomDialog ref='upload' :element='upload.element' :styles='upload.styles1'>
         <template v-slot:dialog-content>
          <AddRecoverDialog ref='addObj'></AddRecoverDialog>
         </template>
   </CustomDialog>

    <CustomDialog
      ref="confirmDel"
      :element="delDeviceDialog"
      :styles="styles">
     <template v-slot:dialog-content>
        <RestoreConfirm ref="delConfirm"></RestoreConfirm>
      </template>
    </CustomDialog>
    <CustomDialog ref='recovery' :element='recoverylDialog.element' :styles='recoverylDialog.styles'>
      <template v-slot:dialog-content>
        <div v-html='recoveryResult'></div>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
import ConfigRecoverTableButton from './ConfigRecoverTableButton.vue';
import { TreeGridPlugin, Page, Resize, RowDD } from "@syncfusion/ej2-vue-treegrid";
import CustomDialog from '../../components/common/CustomDialog';
import AddRecoverDialog from '../../components/system/AddRecoverDialog';
import { EventBus } from '../../plugins/eventBus';
import RestoreConfirm from "./RestoreConfirm";
import Vue from "vue";
Vue.use(TreeGridPlugin);
let dataSource = [];

export default {
  name: "configRecover",
  components: {
    ConfigRecoverTableButton,
    CustomDialog,
    AddRecoverDialog,
    RestoreConfirm
  },
  data() {
    return {
      index: 0,
      isCheckVersion:false,
      dateFormatOptions: { type: 'date', format: 'yyyy-MM-dd HH:mm:ss' },
      nodeList: [],
      curNodeList: [],
      selectedIds: new Set(),
      changeColor: new Set(),
      page: {
        pageNo: 1,
        pageSize: 15,
        totalCount: 0,
        pageCount: 10
      },
      upload: {
        styles: {
          width: '810px',
          height: '752px',
          model: true,
          visible: false
        },
        styles1: {
          width: '500px',
          height: '300px',
          model: true,
          visible: false,
          zIndex: 1000,
        },
        element: {
          refName: "detailLog",
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('Common.confirm') } },
          ],
          title: this.$t('Common.upload')
        },
      },
       delDeviceDialog: {
          target: this.$refs.delConfirm,
          refName: "delConfirm",
          buttonGroup: [
            {
              click: this.closeDelDevice,
              buttonModel: { content: this.$t("Common.cancel") },
            },
            {
              click: this.delDev2Confirm,
              buttonModel: { content: this.$t("Common.confirm") },
            }
          ],
          title: 'Warning',
          isClose: true,
        },
        styles: {
          width: '500px',
          height: '330px',
          visible: false,
          model: true,
        },
        recoverylDialog: {
          styles: {
            width: '810px',
            height: '752px',
            model: true,
            visible: false
          },
          element: {
            refName: "recoveryResult",
            isClose: true,
            buttonGroup: [
              { click: this.recoverylDialogHide, buttonModel: { content: this.$t('System.confirm') }, isPrimary: true }
            ],
            title: this.$t('System.recoveryResult')
          }
        },
        recoveryResult: '',
    }
  },
  methods: {
    request() {
      this.isCheckVersion= false;
      this.selectedIds.clear();
      this.changeColor.clear();
      let key =  this.$refs.recoverButton.input;
      this.axios.post(`/lte/ems/topo/getRecoverViewList`, {
        pageNo: this.$refs.pager.ej2Instances.currentPage,
        pageSize:this.$refs.pager.ej2Instances.pageSize,
        search:key
      }).then((response) => {
        if(response.data.errorCode == 'SUCCESS'){
          dataSource= response.data.resultVal.result;
          this.page.totalCount = response.data.resultVal.totalCount;
          this.page.pageNo = response.data.resultVal.pageNo;
          this.page.pageSize = response.data.resultVal.pageSize;
          this.page.pageCount = response.data.resultVal.totalPages === 0 ? 1: response.data.resultVal.totalPages;
          this.dataBinding(dataSource);
        }
      });
    },
    rowDataBound(args){
      this.nodeList = this.resdata;
      if(args.data.typeCode!=0){
        if(this.changeColor.has(args.data.neName)){
          args.row.bgColor = "#ff0000";
        }
      }
    },
    dataBinding(dataSource) {
     this.resdata = [];
      dataSource.forEach(element => {
        if(element.parentId==null&&element.typeCode==0){
          let master = this.getMaster(element);
          this.resdata.push(master);
        }
      })
      dataSource.forEach(element => {
        if(!(element.parentId==null&&element.typeCode==0)){
          if(element.typeCode==0){
            let master = this.getMaster(element);
            element = master;
          }
          if(element.parentId==null){
            this.resdata.push(this.getNewOne(element));
          }else{
            let hasCont = this.setChildren(this.resdata,element);
            //子数据存在而无父数据时列表展示（主要用于模糊搜索中的所有子任务的场景）
            if(!hasCont)
            {
              this.resdata.push(element)
            }
          }
        }
      });
      console.log("******this.nodeList:", this.resdata)

      this.nodeList = this.resdata;
    },

getMaster(element){
      let master = {};
      master.id = element.id;
      master.neId = element.neId;
      master.neName = element.neName;
      master.neSoftVersion = "-";
      master.curSoftVersion = "-";
      master.fileName = "-";
      master.filePath = "-";
      master.errorCode = "-";
      master.errorString = "-";
      master.intoDbTime = "-";
      master.typeCode = element.typeCode;
      master.state = element.state;
      master.parentId = element.parentId;
      master.subtasks = [];
      return master;
    },
    setChildren(resdata,neObj){
      let hasCont = false;
      resdata.forEach(item => {
        if(item.neId == neObj.parentId)
        {
          item.subtasks.push(this.getNewOne(neObj));
          hasCont= true;
        }else{
          if(typeof item.subtasks!= 'undefined'){
            if(this.setChildren(item.subtasks,neObj)){
              hasCont=  true;
            }
          }
        }
      })
      return hasCont;
    },
getNewOne(element){
      let newElement = {};
      newElement.id = element.id;
      newElement.neId = element.neId;
      newElement.neName = element.neName;
      newElement.neSoftVersion = element.neSoftVersion;
      newElement.curSoftVersion =element.curSoftVersion;
      newElement.fileName = element.fileName;
      newElement.filePath = element.filePath;
      newElement.errorCode =element.errorCode;
      newElement.errorString = element.errorString;
      newElement.intoDbTime = element.intoDbTime;
      newElement.typeCode = element.typeCode;
      newElement.parentId = element.parentId;
      newElement.state = element.state;
      newElement.subtasks = element.subtasks;
      return newElement;
    },
    notice(type) {
      switch (type) {
        case 'add':
          this.addDialog();
          break;
        case 'recover':
          this.openDelDevice();
          break;
        case 'check':
          this.check();
          break;
        case 'refresh':
          this.request();
          break;
        default:
      }
    },
    check(){
      const rows = this.$refs.grid.getRows();
      const selectedRecords = this.getSelect();
      if (selectedRecords.length < 1) {
        EventBus.$emit("toast", {
          type: "warning",
          content: this.$t("Topo.pleaseSelect"),
        });
        return false;
      }
      this.isCheckVersion= true;
      this.selectedIds.clear();
      selectedRecords.forEach(element => {
        this.selectedIds.add(element.neId);
      });
      this.resdata.forEach(element => {
        this.setVersionFlag(element);
      });
      this.$refs.grid.getRows().forEach(element => {
        if(this.changeColor.has(element.cells[1].innerText)){
          element.bgColor='#ff0000';
        }else{
          element.bgColor='';
        }
      });
      this.nodeList = this.resdata;
      // this.nodeList = [...this.nodeList];
    },
    setVersionFlag(element){
      if(this.selectedIds.has(element.neId)&&element.neSoftVersion!=element.curSoftVersion){
        this.changeColor.add(element.neName);
      }
      if(typeof element.subtasks != 'undefined' && element.subtasks.length>0){
        element.subtasks.forEach(element => {
          this.setVersionFlag(element);
        });
      }
    },
    recover(){
      const selectedRecords = this.getSelect();
      this.$layer.confirm({
          msg: this.$t('MML.neCfgRestoreConfirmTip'),
          btn2: {
            msg: this.$t('System.confirm'),
            func: () => {
                 this.doRecoverMethod(selectedRecords);
            }
          },
          btn1: {
            msg: this.$t('MCS.cancle')
          }
      });
    },
    doRecoverMethod(RowDatas){
      this.closeDelDevice();
      let list = [];

      for(let i in RowDatas){
        let param ={
        id:RowDatas[i].id,
        neId:RowDatas[i].neId,
        neName:RowDatas[i].neName,
        fileName:RowDatas[i].fileName,
        filePath:RowDatas[i].filePath
        }
        if(RowDatas[i].id !="" && RowDatas[i].id != undefined){
            list.push(param);
        }
      }
      let flagSuccess = false;
      this.$loading.showLoadding(this.$t('System.loading'));
      this.axios.post(`/lte/ems/config/mml/setRestoreMml`,list).then((response) => {
        if(response.data.errorCode == 'SUCCESS'){
          EventBus.$emit("toast", {
            type: "success",
            content: this.$t("System.restoreSuccess"),
          });
          this.request();
          this.$loading.hideLoadding();
          let resultList = response.data.resultVal;
          let successStr = "";
          let failStr = "";
          resultList.forEach(element => {
            if(element.state == "1"){
              successStr = successStr+element.neName+",";
            }else{
              failStr = failStr+element.neName+",";
            }
          });
          if(successStr != ""){
            successStr = successStr.substring(0,successStr.length-1);
          }
          if(failStr!= ""){
            failStr = failStr.substring(0,failStr.length-1);
          }
          this.recoveryResult = "<ul><li><h5>Success List:</h5>"+successStr+"</li><li><h5>Fail List:</h5>"+failStr+"</h5></li></ul>";
          this.$refs.recovery.show();
          // this.updateRowState(res);
        }else{
          EventBus.$emit("toast", {
            type: "warning",
          content: this.$t("Pm.atMostOneRealTask"),
          });
        }
         this.$loading.hideLoadding();
         flagSuccess = true;
      });
      //增加半小时后恢复的处理
         setTimeout(() => {
            if(!flagSuccess){
         EventBus.$emit("toast", {
            type: "error",
          content: this.$t("MML.recoverFail"),
          });
         this.$loading.hideLoadding();
               }
        }, 21*60*1000);

    },

    openDelDevice() {
       const selectedRecords = this.getSelect();
      if (selectedRecords.length < 1) {
        EventBus.$emit("toast", {
          type: "warning",
          content: this.$t("Topo.pleaseSelect"),
        });
        return false;
      }
          this.recover();
      //this.$refs.confirmDel.show();
    },
     closeDelDevice() {
      this.$refs.confirmDel.clear();
      this.$refs.confirmDel.close();
    },

    delDev2Confirm(){
      const selectedRecords = this.getSelect();
      if (selectedRecords.length < 1) {
        EventBus.$emit("toast", {
          type: "warning",
          content: this.$t("Topo.pleaseSelect"),
        });
        return false;
      }

      this.recover();

    },

    addDialog() {
      this.uploadProps = {status: 1};
      this.$refs.upload.show();
    },
    dialogHide() {
        this.$refs.upload.clear();
        this.$refs.upload.close();
        this.request();
    },
     getSelect() {
            const select = [];
            console.log("-------",this.$refs.grid.getCheckedRecords())
            this.$refs.grid.getCheckedRecords().forEach(item => {
                    select.push(item);
            })
            return select;
    },
     getCheckedData() {
      const selectedRecords = this.getSelect
      if (selectedRecords.length < 1) {
        EventBus.$emit("toast", {
          type: "warning",
          content: this.$t("Topo.pleaseSelect"),
        });
        return false;
      }
      return selectedRecords;
    },
      stateTypeFormatter(field, data, column) {
      if (data[field] === null || data[field] === "") {
        return "---";
      }else if (data[field] === "0"){
         return this.$t("Security.failure")
      }else if (data[field] === "1"){
        return this.$t("Security.success")
      }
      return data[field];
    },
    recoverylDialogHide(){
      this.$refs.recovery.clear();
      this.$refs.recovery.close();
    }
  },

  provide: {
    treegrid: [ Page, Resize, RowDD],
  },
  mounted() {
    this.request();
  }
}
</script>

<style scoped>

</style>
